// VH-285 — what a code and a secret look like (FinanceHub FH-104).

/** A code from the app is six digits. Pasted as "123 456" it is still one. */
export const CODE_LENGTH = 6
export const cleanCode = (text) => String(text || '').replace(/\D/g, '').slice(0, CODE_LENGTH)
export const isFullCode = (code) => cleanCode(code).length === CODE_LENGTH

/** The secret as an app shows it for typing: groups of four. */
export const groupSecret = (secret) => String(secret || '').replace(/(.{4})(?=.)/g, '$1 ')
